/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Match result info in dispute resolution response
 * @export
 * @interface DisputeMatchResult
 */
export interface DisputeMatchResult {
    /**
     * 
     * @type {string}
     * @memberof DisputeMatchResult
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeMatchResult
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeMatchResult
     */
    winnerId?: string;
    /**
     * Score after resolution — set when the admin adjusted it.
     * @type {number}
     * @memberof DisputeMatchResult
     */
    team1Score?: number;
    /**
     * Score after resolution — set when the admin adjusted it.
     * @type {number}
     * @memberof DisputeMatchResult
     */
    team2Score?: number;
}

/**
 * Check if a given object implements the DisputeMatchResult interface.
 */
export function instanceOfDisputeMatchResult(value: object): value is DisputeMatchResult {
    return true;
}

export function DisputeMatchResultFromJSON(json: any): DisputeMatchResult {
    return DisputeMatchResultFromJSONTyped(json, false);
}

export function DisputeMatchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeMatchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
    };
}

export function DisputeMatchResultToJSON(json: any): DisputeMatchResult {
    return DisputeMatchResultToJSONTyped(json, false);
}

export function DisputeMatchResultToJSONTyped(value?: DisputeMatchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'winnerId': value['winnerId'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
    };
}

